module.exports = __webpack_public_path__ + "static/media/ConnectGroup.6e5b968d.jpg";